// extracted by mini-css-extract-plugin
module.exports = {"root":"element_root__IBd6C","iconContainer":"element_iconContainer__eYAtk","icon":"element_icon__dkDfn","nameContainer":"element_nameContainer__rHx7J","name":"element_name__3oKbH"};